import styled from '@emotion/styled';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const StyledSettingWrapper = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  padding: 20px 40px;
  /* padding: 47.65px 40px 46.35px; */
  margin-top: 10px;
  &:first-of-type {
    margin-top: 18px;
  }
  & > strong {
    position: relative;
    display: block;
    width: 200px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
  }
`;
export const StyledSettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  margin-left: 32px;
  padding-top: 10px;
  padding-bottom: 10px;

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -32px;
    background: #e0e0e0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;
export const StyledSettingList = styled.ul`
  position: relative;
  margin-bottom: 30px;
  &.report {
    margin-bottom: 0;
  }

  & > li {
    display: flex;
    white-space: nowrap;
    align-items: center;
    margin-top: 28px;
    font-size: 16px;
    color: #333;
    &:first-of-type {
      margin-top: 0;
    }
  }
  & .guide-text {
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    color: #fa8282;
  }
  & .selectbox-text {
    margin-left: 5px;
    color: #484848;
  }
`;

export const StyledSeriesList = styled.ul`
  display: flex;
  & li {
    display: flex;
    & + li {
      margin-left: 30px;
    }
  }
`;
export const StyledInputList = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  & span {
    font-weight: 400;
    font-size: 14px;
  }
  & li {
    margin-right: 50px;
  }
  & .sub-title {
    width: 150px;
  }
  & .send-off {
    margin-left: 5px;
  }
`;
export const StyledSwButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 53px;
  & button {
    margin-top: 0;
  }
`;

export const StyledSmallTxt = styled.div`
  margin: 0 2px;
  font-size: 10px;
  color: #999;
`;
